import React, { useState, useEffect, FC } from 'react'

type ImageProps = {
  key: string | number
  thumbnailUrl: string
}

const InsideTheStudioImage: FC<ImageProps> = ({ thumbnailUrl, key }) => {
  const [imageDimensions, setImageDimensions] = useState<{ width?: number; height?: number }>({})

  useEffect(() => {
    const img = new Image()
    img.src = thumbnailUrl

    img.onload = () => {
      setImageDimensions({
        height: img.height,
        width: img.width,
      })
    }
  }, [thumbnailUrl])

  return (
    <div data-type='image'>
      <img
        key={`image-detail-${key}`}
        src={thumbnailUrl}
        alt={`Slide ${key}`}
        itemProp='image'
        width={imageDimensions.width}
        height={imageDimensions.height}
      />
    </div>
  )
}

export default InsideTheStudioImage
